import React from 'react'
import {InputContainer, TextAreaPure} from '@modifi/ui'

export const TextAreaWithContainer = props => (
  <InputContainer inputComponent={TextAreaPure} {...props} />
)
